// extracted by mini-css-extract-plugin
export default {"pageWrapper":"MGCQfmGi","editorWrapper":"cEx9MVm4"};